import React from 'react';

import Modal from '@material-ui/core/Modal';

import Backdrop from '@material-ui/core/Backdrop';

import Fade from '@material-ui/core/Fade';

import { InfoAwesomeIcon } from 'app/shared/icons';

import { ButtonLounge } from '../button/button-louge';

import './style.scss';




export interface IModalWithAction {

 showModal?: any;

 setShowModel?: any;

 textBody?: any;

 action?: any;

 btnActionLabel?: any;

 btnCloseLabel?: any;

 icon?: any;

}

const ModalWithAction = ({ showModal, setShowModel, textBody, action, btnActionLabel, btnCloseLabel, icon }: IModalWithAction) => {

const handleClose = () => {

setShowModel(false);

 };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showModal}
      onClose={handleClose}
      className={'modal-container'}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 1500,
      }}
    >
      <Fade in={showModal}>
        <div className="paper-info">
         {icon ?   <img src={icon} />: <InfoAwesomeIcon /> }

          <div className="paper-info-text">{textBody}</div>
          <br />
          <br />
          <div className='desktop-popup-btn pt-1'>
            {btnActionLabel &&(<div style={{ margin: '0.5rem' }}>{''}<ButtonLounge title={btnActionLabel} action={action} style={'1 btn Radius'}/>{''}</div>)}
            {btnCloseLabel &&(<div style={{ margin: '0.5rem' }}>{''}<ButtonLounge title={btnCloseLabel} action={handleClose} style={'1 btn Radius'}/>{''}</div>

            )} 
          </div>

        </div>
      </Fade>
    </Modal>
  );
};

export default ModalWithAction;
